export default function syncNotificationBadge(_badgeCount: number) {}
